import type * as UpdateBasketItem from '@ori-events/update-basket-item';
import type {
  Data as ErrorData,
  UpdateBasketItemResponse,
} from '@ori-events/update-basket-item-failed';
import {
  isUpdateBasketItemErrorResponse,
  Name as ErrorEventName,
} from '@ori-events/update-basket-item-failed';
import type { PositionData } from '@ori/analytics-data';

import { convertToCamelCase, getHttpRequestSettings } from '../helpers';
import { RequestUrl } from '../models';

type Data = PositionData & UpdateBasketItem.Data;

export default async ({ detail: { lineNumber, placement, quantity } }: CustomEvent<Data>) => {
  const request = await fetch(
    `${RequestUrl.UpdateBasketItem}?lineNumber=${lineNumber}&quantity=${quantity}`,
    getHttpRequestSettings({ placement }),
  );

  const response = convertToCamelCase<UpdateBasketItemResponse>((await request.json()) as object);

  if (isUpdateBasketItemErrorResponse(response)) {
    const errorEvent = new CustomEvent<ErrorData>(ErrorEventName, {
      detail: response,
    });
    window.dispatchEvent(errorEvent);

    return false;
  }

  return response;
};
